import DialogPage from "../DialogPage";
import {View} from "react-native";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {ColumnSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import Button from "../components/Button";
import FontAwesome from "../components/FontAwesome";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";

export default function GuestNotAllowed(props: { navigation: any }) {

    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const appFunctions = useContext(AppFunctionsContext);

    return <DialogPage {...props} header={"تایید شماره موبایل"}>
        <FontAwesome icon={""} color={colors.get("primaryColor") as string} size={48}/>
        <ColumnSpace/>
        <Text color={colors.get("highConText") as string} size={14}>
            دسترسی به ثبت سفارش و دیگر امکانات برنامه تنها پس از تایید شماره همراه امکان پذیر است. در کمتر از 30 ثانیه
            شماره همراه خود را تایید کنید.
        </Text>
        <ColumnSpace/>
        <Button color={colors.get("green") as string}
                onPress={()=>{
                    appFunctions.appNavigator.back();
                    appFunctions.appNavigator.toClientInfoEdit();
                }}
                title="ورود به پروفایل برای تایید شماره"/>
        <ColumnSpace/>
        <View style={{justifyContent: "center", alignItems: "center"}}>
            <Button style={{width: "80%"}} color={colors.get("red") as string}
                    onPress={appFunctions.appNavigator.back} title="سفارش نمی دهم"/>
        </View>
    </DialogPage>
}
